import { NumericRange, NumericScalingFunction } from '@ardoq/graph';
import { BubbleRadiusLegend } from './BubbleRadiusLegend';
import {
  BubbleChartDataPointModel,
  BubbleLegendRow,
  RadiusFieldLegendData,
} from '../types';
import { Locale } from '@ardoq/locale';

const getBubbleLegendRow = (
  radiusFieldData: RadiusFieldLegendData,
  chartData: BubbleChartDataPointModel[],
  radiusDomain: NumericRange,
  radiusScaler: NumericScalingFunction,
  radiusUnscaler: NumericScalingFunction,
  showBubblesWithZeroValue: boolean,
  locale: Locale
): BubbleLegendRow[] | undefined => {
  if (!radiusFieldData) {
    return undefined;
  }
  if (chartData.every(({ radius }) => !radius)) {
    // no need for a radius legend when every datapoint has a zero radius.
    return undefined;
  }
  return [
    {
      id: radiusFieldData._id,
      title: radiusFieldData.label,
      sections: [
        {
          heading: null,
          items: [
            {
              getShape: () => (
                <BubbleRadiusLegend
                  chartData={chartData}
                  radiusDomain={radiusDomain}
                  radiusScaler={radiusScaler}
                  radiusUnscaler={radiusUnscaler}
                  includeZero={
                    showBubblesWithZeroValue &&
                    chartData.some(({ radius }) => !radius)
                  }
                  locale={locale}
                />
              ),
              color: 'white',
              style: { paddingBottom: 0 },
            },
          ],
        },
      ],
    },
  ];
};

export { getBubbleLegendRow };
